import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import { FaGraduationCap, FaGamepad } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import Translator from './Translator';
import EnglishQuiz from './EnglishQuiz';
import WistiaPlayer from './WistiaPlayer';

const { FiTrendingUp, FiMap, FiArrowRight } = FiIcons;

const Hero = () => {
  const campusLink = "https://app.onlineclassesenglish.com";
  
  return (
    <section className="relative min-h-screen pt-32 pb-20 overflow-hidden bg-black">
      {/* Background with Gaming Textures */}
      <div className="absolute inset-0 z-0 opacity-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/40 to-black z-10"></div>
        <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1542751371-adc38448a05e?q=80&w=2670&auto=format&fit=crop')] bg-cover bg-center"></div>
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text Content */}
          <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }}>
            <div className="inline-flex items-center gap-2 bg-zinc-900 border border-yellow-500/50 text-yellow-500 px-4 py-1 rounded-full mb-6 text-xs font-black uppercase tracking-widest">
              <SafeIcon icon={FiTrendingUp} className="animate-pulse" /> Nivel Actual: 1. Explorador 🧭
            </div>
            <h1 className="text-5xl md:text-8xl font-black text-white mb-6 leading-[0.85] tracking-tighter uppercase italic">
              Aprende Inglés <br/>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 via-yellow-500 to-green-600">Sin Filtros</span>
            </h1>
            <p className="text-xl text-gray-400 mb-10 max-w-lg leading-relaxed font-medium">
              Tu aventura bilingüe comienza aquí. Desbloquea nuevas oportunidades en la universidad online que funciona como tu videojuego favorito. <span className="text-white">Diseñado para hispanohablantes.</span>
            </p>

            <div className="flex flex-wrap gap-4 mb-12">
              <a href={campusLink} className="bg-yellow-500 text-black px-10 py-5 rounded-2xl font-black text-lg uppercase tracking-widest hover:bg-yellow-400 transition-all flex items-center gap-3 transform hover:scale-105 shadow-2xl shadow-yellow-900/40">
                <SafeIcon icon={FaGamepad} className="text-2xl" /> 🎮 START GAME
              </a>
              <a href="#pricing" className="bg-zinc-900 border-2 border-zinc-700 text-white px-10 py-5 rounded-2xl font-bold text-lg hover:border-green-500 transition-all flex items-center gap-3">
                Ver Planes <FiArrowRight />
              </a>
            </div>

            {/* Video Feature */}
            <div className="max-w-md">
              <WistiaPlayer />
            </div>
          </motion.div>

          {/* Right: Interactive Hub */}
          <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
            <EnglishQuiz />
            <Translator />
            
            <div className="bg-zinc-900/50 border border-zinc-800 p-6 rounded-3xl backdrop-blur-xl">
               <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white shrink-0">
                    <SafeIcon icon={FaGraduationCap} className="text-2xl" />
                  </div>
                  <div>
                    <h4 className="text-white font-black uppercase text-xs">Misión del Día</h4>
                    <p className="text-gray-400 text-sm">Completa el quiz y gana 500 XP para tu cuenta.</p>
                  </div>
               </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;